import publicRoutes from '@/router/routes/public-routes';
import appRoutes from '@/router/routes/app-routes';

export default [
  ...publicRoutes,
  ...appRoutes,
];
